import React from 'react';

const MenuGaveta = ({ onClose }) => {

  const handleNavigation = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    if (onClose) {
      onClose();
    }
  };

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.menuContainer} onClick={(e) => e.stopPropagation()}>
        
        <div style={styles.menuHeader}>
          <button onClick={onClose} style={styles.closeButton}>
            ✕
          </button>
        </div>

        <nav style={styles.navLinks}>
          <button onClick={() => handleNavigation('hero')} style={styles.link}>Início</button>
          <button onClick={() => handleNavigation('depoimentos')} style={styles.link}>Depoimentos</button>
          <button onClick={() => handleNavigation('faq')} style={styles.link}>Dúvidas</button>
          
          <button onClick={() => handleNavigation('ofertas')} style={styles.ctaMobile}>
            COMPRAR AGORA
          </button>
        </nav>

      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)', 
    zIndex: 2000,
    display: 'flex',
    justifyContent: 'flex-start'
  },
  menuContainer: {
    width: '85%',
    maxWidth: '300px',
    height: '100%',
    backgroundColor: '#fff', 
    padding: '25px',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '5px 0 15px rgba(0,0,0,0.1)',
    animation: 'slideIn 0.3s ease-out',

    borderTopRightRadius: '20px'
  },
  menuHeader: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginBottom: '40px'
  },
  closeButton: {
    background: 'none',
    border: 'none',
    fontSize: '2rem',
    color: '#513D8B', 
    cursor: 'pointer',
    padding: '0',
    lineHeight: '1'
  },
  navLinks: {
    display: 'flex',
    flexDirection: 'column',
    gap: '30px'
  },
  link: {
    background: 'none',
    border: 'none',
    textAlign: 'left',
    fontSize: '1.2rem',
    color: '#513D8B', 
    fontFamily: '"Commissioner", sans-serif',
    fontWeight: '600',
    cursor: 'pointer',
    padding: 0
  },
  ctaMobile: {
    marginTop: '20px',
    backgroundColor: '#DB6533', 
    color: '#fff',
    border: 'none',
    padding: '15px',
    borderRadius: '30px',
    fontWeight: 'bold',
    fontSize: '1rem',
    cursor: 'pointer',
    fontFamily: '"Commissioner", sans-serif'
  }
};


const styleSheet = document.createElement("style");
styleSheet.innerText = `
  @keyframes slideIn {
    from { transform: translateX(-100%); }
    to { transform: translateX(0); }
  }
`;
document.head.appendChild(styleSheet);

export default MenuGaveta;